import { type UserInfoType } from "~/src/models/profile/user-info";
import { type AxiosError } from "axios";
import { type RequestError } from "~/src/models/error";
import { queryOptions } from "@tanstack/react-query";
import { userApi } from "~/src/apis/user";
import { userProfileKey } from "~/src/constants/user-profile-key";

/** Public endpoint shared by wallet identity, profile and settings. */
export const userProfileQueryOptions = (
  address?: string
): ReturnType<typeof queryOptions<UserInfoType, AxiosError<RequestError>>> => {
  const normalizedAddress = address?.toLowerCase() ?? "";
  return queryOptions<UserInfoType, AxiosError<RequestError>>({
    queryKey: userProfileKey(normalizedAddress),
    queryFn: async ({ signal }) =>
      await userApi.getUnAuthorizedUser(normalizedAddress, signal),
    enabled: !!normalizedAddress,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    retry: false,
  });
};
